import { withStyles } from '@material-ui/core';

import BulkActionsRow from './component';
import styles from './styles';

export default withStyles(styles)(BulkActionsRow);
